import React, { FC } from 'react'
import { UseFormMethods } from 'react-hook-form'
import ControlledFacetRadioGroup from 'transfix-form/components/ControlledFacetGroup'
import { makeStyles } from 'transfix-ui/core'
import { TCarrierOptionSchema, getErrorMessage } from '../../schema'
import { SOURCE_CHANNEL_OPTIONS, SOURCE_SEGMENT_OPTIONS, TEST_IDS } from './constants'

const useSourceFormSectionStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
}))

export interface ISourceFormSectionProps
  extends Pick<UseFormMethods<TCarrierOptionSchema>, 'control' | 'errors'> {}

const SourceFormSection: FC<ISourceFormSectionProps> = ({ control, errors }) => {
  const classes = useSourceFormSectionStyles()

  const sourceChannelErrors = getErrorMessage(errors, 'sourceChannel')
  const sourceSegmentErrors = getErrorMessage(errors, 'sourceSegment')

  return (
    <div className={classes.root}>
      <div>
        <ControlledFacetRadioGroup
          control={control}
          name='sourceChannel'
          FacetRadioGroupProps={{
            label: 'Source Channel',
            required: true,
            options: SOURCE_CHANNEL_OPTIONS,
            dataTest: TEST_IDS.sourceChannelFacet,
            errorMessage: sourceChannelErrors,
          }}
        />
      </div>
      <div>
        <ControlledFacetRadioGroup
          control={control}
          name='sourceSegment'
          FacetRadioGroupProps={{
            label: 'Source Segment',
            required: true,
            options: SOURCE_SEGMENT_OPTIONS,
            dataTest: TEST_IDS.sourceSegmentFacet,
            errorMessage: sourceSegmentErrors,
          }}
        />
      </div>
    </div>
  )
}

export default SourceFormSection
